import { render, staticRenderFns } from "./AssetListItem.vue?vue&type=template&id=2abf9c4c&scoped=true&"
import script from "./AssetListItem.vue?vue&type=script&lang=js&"
export * from "./AssetListItem.vue?vue&type=script&lang=js&"
import style0 from "./AssetListItem.vue?vue&type=style&index=0&id=2abf9c4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf9c4c",
  null
  
)

/* custom blocks */
import block0 from "./AssetListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports